export default __webpack_public_path__ + "static/char-s-35-zh-Hans-38b8c427b5134653f8496936558cfae2.png";